<ul class="menu-wrapper menu-horizontal-wrapper">
  <ng-container *ngFor="let item of menu">
    <ng-container *appHasLicenseModule="item.modules">
      <li *appHasRole="item.roles">
        <div class="menu-item" [class.active]="isRouteActive(item)">
          <a *ngIf="!item.children" class="menu-item-link" [routerLink]="item.link">
            <span [ngClass]="item.icon" [title]="item.name"></span>
          </a>

          <button *ngIf="item.children" class="menu-item-link" (click)="showSubmenu(item)">
            <span [ngClass]="item.icon" [title]="item.name"></span>
          </button>
        </div>
      </li>
    </ng-container>
  </ng-container>
</ul>
